import { render, staticRenderFns } from "./MatchingQuestion.vue?vue&type=template&id=27d94efc&"
import script from "./MatchingQuestion.vue?vue&type=script&lang=js&"
export * from "./MatchingQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports